export default __webpack_public_path__ + "static/media/logo-walletconnect.1f8b2e6c.png";